import React from 'react';
import {
  graphql,
  createRefetchContainer,
} from 'react-relay';

import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import { useCommonStyles } from '../common/Styles';
import TableFieldMeta from '../../common/TableFieldMeta';
import BaseGridContainer from '../common/BaseGridContainer';
import { ROWS_PER_PAGE } from '../../common/constants';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import TablePaginator from '../common/TablePaginator';
import RTTableRenderer from '../common/table/RTTableRenderer';
import InnerTabFilterToggleButtonGroup from '../common/innerTab/InnerTabFilterToggleButtonGroup';

const processedAtIsnullDefault = null;
const ignoredDefault = null;

function IBFlexQueryList(props) {
  const {
    viewer,
    relay,
    filter,
  } = props;
  filter.setRelay(relay);

  const classes = useCommonStyles();
  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.field('fromDate', 'From'),
    TableFieldMeta.field('toDate', 'To'),
    TableFieldMeta.field('queryType', 'Type'),
    TableFieldMeta.field('creates', 'Creates'),
    TableFieldMeta.field('updates', 'Updates'),
    TableFieldMeta.fieldCell('fileUrl', 'File', (row) => {
      if (!row.value.responseUrl) {
        return null;
      }
      return <Link href={row.value.responseUrl}>{row.value.response}</Link>;
    }, { accessor: x => x, width: 300 }),
  ];
  return (
    <div className={classes.innerTabRoot}>
      <BaseGridContainer>
        <InnerTabFilterToggleButtonGroup
          enumType="IBFlexQueryType"
          idToolTipMode
          onChange={newVal => filter.updateVar('queryType', newVal)}
          withNull
          defaultValue={null}
          helperText="Status Filter"
        />

        <Grid item xs={12}>
          <TablePaginator
            columns={columns}
            filter={filter}
            getDataNode={() => (viewer ? viewer.ibFlexQueryRequests : null)}
            tableRender={RTTableRenderer}
          />
        </Grid>

      </BaseGridContainer>
    </div>
  );
}

IBFlexQueryList.propTypes = {
};

IBFlexQueryList.defaultProps = {
};

const query = graphql`
  query IBFlexQueryListQuery (
    $first: Int
    $offset: Int
    $queryType: String
  ) {
    viewer {
      ...IBFlexQueryList_viewer
      @arguments (
        first: $first
        offset: $offset
        queryType: $queryType
      )
    }
  }
`;

const container = createRefetchContainer(
  IBFlexQueryList,
  {
    viewer: graphql`
      fragment IBFlexQueryList_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10}
        offset: {type: Int}
        queryType: {type: String}
      ) {
        
        ibFlexQueryRequests(
          first: $first,
          offset: $offset,
          queryType: $queryType,
          orderBy: "-createdAt"
        ) {
          count
          edges {
            node {
              id
              queryType
              response
              responseUrl
              updates
              creates
              fromDate
              toDate
              fetchUrl
            }
          }
          pageInfo{
            endCursor
            startCursor
            hasNextPage
            hasPreviousPage
          }
        }
      }
    `,
  },
  query,
);
export default withRouter(createQueryRendererProgressV2(
  query,
  container,
  {},
  ({ rowsPerPage }) => ({
    first: rowsPerPage || ROWS_PER_PAGE,
    search: null,
    reportDate: null,
    processedAt_Isnull: processedAtIsnullDefault,
    ignored: ignoredDefault,
  }),
  {
    debounceFields: ['search'],
  },
));
